// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"ContentWrapper_content_wrapper__1aMDx","full_size":"ContentWrapper_full_size__1ljsr","wider":"ContentWrapper_wider__1MPVI"};